const styles = (theme) => ({
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    left: 0,
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  container: { display: "flex", flexDirection: "column", gap: 2 },
});

export default styles;
